import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["error", "value", "handleBlur", "handleChange", "name", "required", "initialValue", "disabled", "onAutoFill", "isAutoFill", "displayName"];
import React, { useRef } from 'react';
import { Box, Flex, Caption, PhoneInput as BaseComponent, Alert } from '@xceedsrl/jukebox';
import { useTranslation } from '../i18n/I18nProvider';
var parsedCountry = {
  ca: 'ES',
  en: 'GB'
};
function PhoneInput(_ref) {
  var error = _ref.error,
    value = _ref.value,
    handleBlur = _ref.handleBlur,
    handleChange = _ref.handleChange,
    name = _ref.name,
    required = _ref.required,
    initialValue = _ref.initialValue,
    disabled = _ref.disabled,
    onAutoFill = _ref.onAutoFill,
    isAutoFill = _ref.isAutoFill,
    displayName = _ref.displayName,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    lang = _useTranslation.lang;
  var initialCountry = parsedCountry[lang] || lang.toUpperCase();
  var phoneRef = useRef();
  return React.createElement(Flex, {
    position: "relative",
    height: "40px"
  }, React.createElement(BaseComponent, _extends({
    key: name,
    "data-testid": "input--" + name,
    name: name,
    onBlur: handleBlur,
    onChange: handleChange,
    wrapperStyle: {
      backgroundColor: disabled ? '#e6e9eb' : '#fff',
      color: '#36424a',
      border: disabled ? '1px solid #e6e9eb' : '1px solid #b9c4c9',
      borderRadius: '6px',
      padding: '5px 8px',
      fontSize: '16px',
      lineHeight: '24px'
    },
    style: {
      width: '100%'
    },
    initialCountry: initialCountry,
    isValid: !error && !!value,
    onAutoFill: onAutoFill,
    value: value,
    disabled: disabled,
    checkmarkTop: "12px",
    ref: phoneRef,
    placeholder: displayName
  }, props)), !required && !value && React.createElement(Box, {
    position: "absolute",
    bottom: "3px",
    right: 2
  }, React.createElement(Caption, null, t('optional'))), !isAutoFill && error && value && React.createElement(Box, {
    position: "absolute",
    bottom: "-60%",
    style: {
      whiteSpace: 'nowrap'
    }
  }, React.createElement(Alert, {
    color: "feeling.negative"
  }, error)));
}
export default React.memo(PhoneInput);